import { render, staticRenderFns } from "./search-list.vue?vue&type=template&id=4dc404d2&"
import script from "./search-list.vue?vue&type=script&lang=js&"
export * from "./search-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports